
<template>
  <div class="container">
      <div class="media-icon">
        <i class="fa fa-mobile"></i>
      </div>

      <div class="details">
          <p class="alias">Asad's ipad</p>
          <p class="alias">entree on iPad pro</p>
      </div>
        <!-- TODO: add collapse functionality and fetch data from props -->
      <div class="last-container end">
            <i class="fa fa-angle-down more"></i>
        </div>
  </div>
</template>

<script>
export default {
    name: 'device-item',
    props: {
        msg: String
    }
};
</script>

<style lang="scss" scoped>
</style>
